import { render, staticRenderFns } from "./CardStatistic.vue?vue&type=template&id=49433d92&"
import script from "./CardStatistic.vue?vue&type=script&lang=js&"
export * from "./CardStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports